import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import { instanceOf } from "prop-types";

export const BillingTitleColumns = ({ billColumns }) => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} />
        {billColumns.map((column, index) => (
            <GridTable.Data columnStart={index + 2} rowStart={1} rowWidth={1}>
                <span>{column}</span>
            </GridTable.Data>
        ))}
    </>
);

BillingTitleColumns.propTypes = {
    billColumns: instanceOf(Array).isRequired,
};
export default BillingTitleColumns;
